import * as React from "react";

import { Separator as PrimitiveSeparator } from "../../primitive/separator";

export type SeparatorProps = React.ComponentProps<typeof PrimitiveSeparator>;

export const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(
  (props, ref) => {
    return <PrimitiveSeparator ref={ref} {...props} />;
  },
);

Separator.displayName = "Separator";
